/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feature_Animation_Allowlist_TitleInputs */

const en_feature_animation_allowlist_title = /** @type {(inputs: Feature_Animation_Allowlist_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="@@">0 distractions</span>, 100% focus power with Plus.`)
};

const ar_feature_animation_allowlist_title = /** @type {(inputs: Feature_Animation_Allowlist_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="@@">0 مُشتّتات</span>، تركيز بنسبة 100٪ مع بلس.`)
};

const de_feature_animation_allowlist_title = /** @type {(inputs: Feature_Animation_Allowlist_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="@@">0 Ablenkungen</span>, 100% Fokusleistung mit Plus.`)
};

const es_feature_animation_allowlist_title = /** @type {(inputs: Feature_Animation_Allowlist_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="@@">0 distracciones</span>, 100% de poder de concentración con Plus.`)
};

const fr_feature_animation_allowlist_title = /** @type {(inputs: Feature_Animation_Allowlist_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="@@">0 distraction</span>, 100 % de concentration avec Forest Plus`)
};

const it_feature_animation_allowlist_title = /** @type {(inputs: Feature_Animation_Allowlist_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="@@">0 distrazioni</span>, potenza di concentrazione al 100% con Plus.`)
};

const ja_feature_animation_allowlist_title = /** @type {(inputs: Feature_Animation_Allowlist_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="@@">邪魔ゼロ</span>。Plusで集中力100％を`)
};

const ko_feature_animation_allowlist_title = /** @type {(inputs: Feature_Animation_Allowlist_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus로 <span style="@@">방해 요소 제거</span>, 집중력 100% 달성.`)
};

const pt_br_feature_animation_allowlist_title = /** @type {(inputs: Feature_Animation_Allowlist_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="@@">0 distrações</span>, 100% de poder de foco com o Plus.`)
};

const ru_feature_animation_allowlist_title = /** @type {(inputs: Feature_Animation_Allowlist_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="@@">0 отвлекающих факторов</span>, 100% мощности фокусировки вместе с Plus.`)
};

const th_feature_animation_allowlist_title = /** @type {(inputs: Feature_Animation_Allowlist_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="@@">0 สิ่งรบกวน</span> โฟกัสเต็มพลัง 100% ด้วย Plus`)
};

const tr_feature_animation_allowlist_title = /** @type {(inputs: Feature_Animation_Allowlist_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="@@">0 dikkat dağıtıcı unsur</span>Plus ile %100 odaklanma gücü.`)
};

const zh_cn_feature_animation_allowlist_title = /** @type {(inputs: Feature_Animation_Allowlist_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="@@">排除诱惑干扰</span>，
让你的学习效率火力全开`)
};

const zh_tw_feature_animation_allowlist_title = /** @type {(inputs: Feature_Animation_Allowlist_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="@@">排除誘惑干擾</span>，
讓你的學習效率火力全開`)
};

/**
* | output |
* | --- |
* | "<span style=\"@@\">0 distractions</span>, 100% focus power with Plus." |
*
* @param {Feature_Animation_Allowlist_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const feature_animation_allowlist_title = /** @type {((inputs?: Feature_Animation_Allowlist_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feature_Animation_Allowlist_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_feature_animation_allowlist_title(inputs)
	if (locale === "ar") return ar_feature_animation_allowlist_title(inputs)
	if (locale === "de") return de_feature_animation_allowlist_title(inputs)
	if (locale === "es") return es_feature_animation_allowlist_title(inputs)
	if (locale === "fr") return fr_feature_animation_allowlist_title(inputs)
	if (locale === "it") return it_feature_animation_allowlist_title(inputs)
	if (locale === "ja") return ja_feature_animation_allowlist_title(inputs)
	if (locale === "ko") return ko_feature_animation_allowlist_title(inputs)
	if (locale === "pt_br") return pt_br_feature_animation_allowlist_title(inputs)
	if (locale === "ru") return ru_feature_animation_allowlist_title(inputs)
	if (locale === "th") return th_feature_animation_allowlist_title(inputs)
	if (locale === "tr") return tr_feature_animation_allowlist_title(inputs)
	if (locale === "zh_cn") return zh_cn_feature_animation_allowlist_title(inputs)
	return zh_tw_feature_animation_allowlist_title(inputs)
});